<template>
  <div class="footer">
    <div class="footer-container">
      <img
        class="footer-logo"
        src="/assets/footer_logo.png"
        alt="엘지 유플러스 로고"
      />
      <div class="copyright">
        <ul class="copyright-menu">
          <li>
            <a title="새창열림" target="_blank" tabindex="0" href="https://www.lguplus.com/about/ko"
              >회사소개</a>
          </li>
          <li>
            <a title="새창열림" target="_blank" tabindex="1" href="https://www.lguplus.com/footer/agreement"
              >이용약관</a>
          </li>
          <li>
            <a
              title="새창열림"
              target="_blank" tabindex="2"
              href="https://www.lguplus.com/uhdc/fo/fcmm/comm/file/v1/no/2302031259372740147"
              ><em class="bold-text">위치정보이용약관</em></a>
          </li>
          <li>
            <a
              title="새창열림"
              target="_blank" tabindex="3"
              href="http://p-policy.uplus.co.kr/privacy/info/v1"
              ><strong style="font-weight: bolder">개인정보처리방침</strong></a
            >
          </li>
          <li>
            <a title="새창열림" target="_blank" tabindex="4" href="https://www.lguplus.com/footer/personal-information/communication-data"
              >통신자료제공사실열람</a>
          </li>
          <li>
            <a title="새창열림" target="_blank" tabindex="5" href="https://www.lguplus.com/footer/children-protection"
              >청소년보호정책</a>
          </li>
          <li>
            <a title="새창열림" target="_blank" tabindex="6" href="https://www.lguplus.com/support/service/user-protection-guide"
              >이용자피해예방가이드</a>
          </li>
          <li>
            <a title="새창열림" target="_blank" tabindex="7" href="https://www.lguplus.com/footer/pending-refund"
              >미환급금조회</a>
          </li>
          <li>
            <a title="새창열림" target="_blank" tabindex="9" href="https://www.msafer.or.kr/index.do"
              >명의도용방지서비스</a>
          </li>
          <li>
            <a title="새창열림" target="_blank" tabindex="10" href="https://www.lguplus.com/footer/issue-status"
              >장애현황</a>
          </li>
        </ul>
        <br />
        <div>
          <ul>
            <li>
              <em class="bold-text">(주)엘지유플러스</em><span> 주소</span>
              <address>서울특별시 용산구 한강대로 32</address>
            </li>
            <li><span class="bold-text">대표이사</span> 홍범식</li>
            <li><span class="bold-text">사업자 등록번호</span> 220-81-39938</li>
            <li>
              <span class="bold-text">통신판매신고</span> 제
              2015-서울용산-00481호
            </li>
            <li>
              <span class="bold-text"
                ><a
                  target="_blank"
                  title="새창열림"
                  href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2208139938"
                  >사업자정보확인</a></span>
            </li>
          </ul>
          <ul>
            <li>
              <span class="bold-text">고객센터</span> 휴대폰 114(무료),
              1544-0010(유료)
            </li>
            <li><span class="bold-text">인터넷/IPTV/전화</span> 101</li>
            <li><span class="bold-text">U+Shop</span> 1644-7099(유료)</li>
          </ul>
        </div>
        <br />
        <p>COPYRIGHT (C) LG Uplus Corp. ALL RIGHTS RESERVED.</p>
      </div>
    </div>
    <RejectCollectingEmailPopup />
  </div>
</template>

<script>
import RejectCollectingEmailPopup from './popup/RejectCollectingEmailPopup'
export default {
  name: 'RegistrationFooter',

  components: {
    RejectCollectingEmailPopup
  },

  methods: {
    /** 
     * Function    : clickTerms
     * Description : 이용약관 상세보기
     **/
    clickTerms() {
      let routeData = this.$router.resolve({ name: 'OpenMarketTerms' })
      window.open(
        routeData.href,
        'PopupWin',
        'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
      )
    },

    /** 
     * Function    : rejectCollectingEmailPopup
     * Description : 이메일주소 무단수집거부 상세보기
     **/
    rejectCollectingEmailPopup() {
      this.$modal.show('RejectCollectingEmail')
    },
  }
}
</script>

<style scoped></style>
